<template>
  <div class="card is-min-width-800">
    <header class="bandeau-modal card-header"></header>
    <div class="pd-20px height-auto">
      <div class="modal-title title has-text-centered mgb-20px">
        <p class="is-size-5 has-text-weight-bold">
          {{ $t('popupAjoutContactTiersFromParent.header.title') }}
        </p>
      </div>
      <div class="card-content  mgb-20px">
        <div class="level">
          <div class="level-left">
            <div class="columns">
              <div class="column is-narrow">
                <selecteur-action @handleAction="handleAction" :options="actions"
                  :placeholder='$t("general.placeHolder.groupedAction")'
                  :elementsSelectionnes="getAllSelected().length > 0"
                  titleButton="general.button.apply">
                </selecteur-action>
              </div>
            </div>
          </div>
        </div>
        <div class="max-height-700 overflow-auto">
          <v-client-table ref="contactsTiers"
            :data="contacts"
            :columns="columns"
            :options="options">
            <div slot="prenomNom" slot-scope="props">
              {{ getPrenomNom(props.row) }}
            </div>
            <div slot="selected" slot-scope="props" class="has-text-centered">
              <b-checkbox v-model="props.row.selected" :value="props.row"
                @input="selectRow(props.row)">
              </b-checkbox>
            </div>
          </v-client-table>
        </div>
        <b-modal v-model="popUpPreventionAjout" has-modal-card class="modal">
          <pop-up-prevention
            :mess-header="
              $t('popupAjoutContactTiersFromParent.popUpPreventionAjout.title')"
            :cancel="$t('general.non')"
            :validate="$t('general.oui')"
            @no="popUpPreventionAjout = false"
            @yes="ajouter" />
        </b-modal>
        <footer>
          <b-field>
            <div class="is-pulled-right boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { cloneDeep } from 'lodash';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_POP_UP,
  TEXTS,
  SORT_ICON,
} from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';
import { getAllByTiers } from '@/api/contacts';
import createAll from '@/api/contactTiers';
import selecteurAction from '@/components/general/selecteurAction';
import { TIERS } from '@/configuration/permissionsBodacConf';
import { ACTION_MASS_AJOUTER_CONTACT_PORTAIL } from '@/configuration/tiers/tiersConf';
import popUpPrevention from '@/components/general/popUpPrevention';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    tiersFromId: {
      type: String,
      required: true,
    },
    tiersToId: {
      type: String,
      required: true,
    },
    currentContacts: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    selecteurAction,
    popUpPrevention,
  },
  data() {
    return {
      permsTiers: TIERS,
      contacts: [],
      createAll,
      popUpPreventionAjout: false,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    columns() {
      return ['selected', 'prenomNom'];
    },
    iconSelectTotal() {
      if (this.allItemsSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allItemsSelected() {
      return this.getAllSelected().length === this.contacts.length
        && this.contacts.length > 0;
    },
    actions() {
      return [
        {
          action: ACTION_MASS_AJOUTER_CONTACT_PORTAIL,
          translation: 'popupAjoutContactTiersFromParent.actions.addContact',
        },
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          prenomNom: this.$t('popupAjoutContactTiersFromParent.tab.prenomNom'),
          selected: (h) => {
            return h(
              'div', {
                attrs: {
                  class: 'pointer has-text-centered',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        sortable: ['prenomNom'],
        customSorting: {
          prenomNom: (ascending) => {
            return (rowA, rowB) => {
              if (ascending) {
                return this.getPrenomNom(rowA) > this.getPrenomNom(rowB) ? -1 : 1;
              }
              return this.getPrenomNom(rowA) < this.getPrenomNom(rowB) ? -1 : 1;
            };
          },
        },
        columnsClasses: {
          selected: 'colonneSelected',
        },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    selectAll() {
      const state = !this.allItemsSelected;
      this.contacts.forEach(item => {
        item.selected = state;
      });
    },
    selectRow(row) {
      this.contacts.forEach(item => {
        if (item.id === row.id) {
          item.selected = !item.selected;
        }
      });
    },
    getAllSelected() {
      return this.contacts.filter((el) => el.selected);
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_AJOUTER_CONTACT_PORTAIL:
          if (this.checkPermissions(this.permsTiers.maj)) {
            this.popUpPreventionAjout = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFactures.error.noActionSelect'));
          break;
      }
    },
    isAlreadyAdded(contact) {
      return this.currentContacts
        .some(currentContact => currentContact.id === contact.id);
    },
    async ajouter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const listeContactTiers = cloneDeep(this.getAllSelected())
          .map(contact => ({ tiersId: this.tiersToId, contactId: contact.id }));
        await this.createAll(listeContactTiers);
        this.$emit('update');
        this.popUpPreventionAjout = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getPrenomNom(row) {
      const prenom = row.prenom ?? '';
      const nom = row.nom ?? '';
      return `${prenom} ${nom}`.trim();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const contacts = (await getAllByTiers(this.tiersFromId))
        .data.result.items
        .filter(contact => !this.isAlreadyAdded(contact));
      contacts?.forEach(contact => {
        contact.selected = false;
      });
      if (contacts?.length > 0) this.contacts = contacts;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
